import React from "react";
// ANT DESIGN COMPONENTS
import { Empty } from "antd";
// REDUX
import { useSelector } from "react-redux";
// NAVIGATION
import { useLocation } from "react-router-dom";
// CUSTOM HOOKS
import useGetOneAdapter from "../../../../customHooks/GET_requests/useGetOneAdapter";
// COMPONENTS
import OffsetTable from "./OffsetTable";
// INTERFACES
import { RootState } from "../../../../app/store";
import { AdapterProtocol } from "../../../../flatbuffers/generated/archive/adapter-protocol";

export default function OffsetPage() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const location = useLocation();
  const adapterId = new URLSearchParams(location.search).get("idAdapter");
  const VALID_PROTOCOL_TYPES_OFFSETS: AdapterProtocol[] = [
    AdapterProtocol.LN1,
    AdapterProtocol.BACNET,
    AdapterProtocol.LOBBYVISION,
    AdapterProtocol.CGA,
    AdapterProtocol.RVU,
  ];

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { adapter, isLoadingGetOneAdapter } = useGetOneAdapter({
    id: adapterId ?? "",
  });

  // ************************************************ */
  // HELPERS **************************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // USE MEMO *************************************** */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE CALLBACK *********************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {adapter && VALID_PROTOCOL_TYPES_OFFSETS.includes(adapter.protocolType) ? (
        <div className={`layout__contentPage__${theme} mt-3`}>
          <OffsetTable adapter={adapter} isLoading={isLoadingGetOneAdapter} />
        </div>
      ) : (
        <div className={`layout__contentPage__${theme} mt-3`}>
          <Empty />
        </div>
      )}
    </div>
  );
}
